import React from 'react';
import { Button, Space } from 'antd';
import {
  showSuccess,
  showError,
  showInfo,
  showWarning,
  withNotification,
} from '../../utils/notificationUtils';

/**
 * Component to demonstrate different notification types
 */
const NotificationExample: React.FC = () => {
  // Simple examples
  const handleSuccessClick = () => {
    showSuccess('Thao tác thành công', 'Dữ liệu đã được lưu thành công');
  };

  const handleErrorClick = () => {
    showError('Thao tác thất bại', 'Không thể lưu dữ liệu, vui lòng thử lại');
  };

  const handleInfoClick = () => {
    showInfo('Thông tin', 'Hệ thống sẽ bảo trì lúc 23:00 hôm nay');
  };

  const handleWarningClick = () => {
    showWarning('Cảnh báo', 'Hàng tồn kho sắp hết, vui lòng nhập thêm hàng');
  };

  // Real API call example
  const realApiCall = async (): Promise<{ success: boolean }> => {
    const response = await fetch('/api/test-endpoint');
    if (!response.ok) {
      throw new Error('Lỗi kết nối máy chủ');
    }
    return await response.json();
  };

  // Using withNotification for API calls
  const handleApiCallSuccess = async () => {
    await withNotification(
      async () => {
        return await realApiCall();
      },
      {
        successMessage: 'API gọi thành công',
        errorMessage: 'API gọi thất bại',
        showSuccessNotification: true,
      }
    );
  };

  // Using withNotification with custom options
  const handleApiCallCustom = async () => {
    try {
      await withNotification(
        async () => {
          const result = await realApiCall();
          // Additional logic here
          return result;
        },
        {
          successMessage: 'Dữ liệu đã được cập nhật',
          errorMessage: 'Không thể cập nhật dữ liệu',
          errorTransform: (error) => ({
            message: 'Lỗi xử lý',
            description: `Chi tiết lỗi: ${error.message}`,
          }),
        }
      );
    } catch (error) {
      console.error('Đã xử lý lỗi:', error);
    }
  };

  return (
    <div className='p-6 bg-white rounded-lg shadow-md'>
      <h2 className='text-lg font-medium mb-4'>Ví dụ thông báo</h2>

      <h3 className='text-md font-medium mb-2'>Các loại thông báo cơ bản</h3>
      <Space className='mb-6'>
        <Button type='primary' onClick={handleSuccessClick}>
          Thông báo thành công
        </Button>
        <Button danger onClick={handleErrorClick}>
          Thông báo lỗi
        </Button>
        <Button onClick={handleInfoClick}>Thông báo thông tin</Button>
        <Button type='default' onClick={handleWarningClick}>
          Thông báo cảnh báo
        </Button>
      </Space>

      <h3 className='text-md font-medium mb-2 mt-4'>Ví dụ với API</h3>
      <Space>
        <Button type='primary' onClick={handleApiCallSuccess}>
          Gọi API (mặc định)
        </Button>
        <Button onClick={handleApiCallCustom}>Gọi API (tùy chỉnh)</Button>
      </Space>
    </div>
  );
};

export default NotificationExample;
